import { useSelector } from 'react-redux';
import { hasAiAlertSelector, selectedAiAlertSelector } from '@store/trends/aiAlerts/selectors';

/**
 * On the AI-alert diagnostics page, KPI-based alerts carry the exact KPI config the
 * alert was generated with in `selectedAiAlert.meta` (kpiID, kpiName, and the per-metric
 * thresholds like BitrateKbps / VideoStartupTimeMilliSec). Metric calls on the diagnostics
 * page must use THAT config — not the globally-selected KPI — so the % KPI metrics
 * (HighStartupTimePercentage, LowBitratePercentage, ...) are computed against the same
 * thresholds that produced the alert.
 *
 * Returns null when not applicable (not on the diagnostics page, or a non-KPI alert whose
 * `meta` is absent) so callers fall back to the current KPI config and existing behavior is
 * unchanged.
 */
export function useAiAlertDiagnosticsKpiConfig(): any {
  const hasAiAlert = useSelector(hasAiAlertSelector);
  const selectedAiAlert = useSelector(selectedAiAlertSelector);

  if (!hasAiAlert) {
    return null;
  }

  // `meta` is only populated for KPI-based alerts and is itself a kpiConfig object.
  // Require kpiID so we never send a partial/bogus config to the metrics API.
  const meta = selectedAiAlert?.meta;
  if (meta && typeof meta === 'object' && meta.kpiID != null) {
    return meta;
  }

  return null;
}

export default useAiAlertDiagnosticsKpiConfig;
